import React, {useEffect, useState} from 'react';
import {DownloadIcon, UploadIcon} from "../../../assets/icons/Icons";
import UploadButton from "../../form/UploadButton";
import CsvUploadLoaderBackground from "../../../assets/images/loading-data-placeholder.png";
import {BulkCreateOfficesTemplateInfo, DownloadOfficesCsvTemplate} from "../../../api";
import {useTranslation} from "react-i18next";

const UploadCsv = ({onUpload, ...props}) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [templateInfo, setTemplateInfo] = useState([]);

    const handleDownloadButtonClick = async (e) => {
        try {
            await DownloadOfficesCsvTemplate();
        } catch (error) {
            console.error('Failed to download offices template:', error);
        }
    }

    useEffect(() => {
        const requestTemplateInfo = async () => {
            try {
                setLoading(true);
                setTemplateInfo(await BulkCreateOfficesTemplateInfo());
                setLoading(false);
            } catch (err) {
                console.log(err);
            }

        }
        requestTemplateInfo();
    }, []);

    return (
        <div className="step">
            <div className="upload-csv">
                <div className="row mb-2">
                    <div className="col-xs-8">
                        <p>{t("To begin, please download the spreadsheet form and fill it out with your office details. When complete, upload the file and your office entries will be listed below.")}</p>
                    </div>
                    <div className="col-xs-4 text-right">
                        <button onClick={e => handleDownloadButtonClick(e)}
                                className="btn btn-secondary btn-medium">
                            <DownloadIcon/>
                            {t("Download")}
                        </button>
                        <UploadButton accept=".csv" class="btn btn-primary btn-medium ml-2" title={<><UploadIcon/>Upload CSV</>} onChange={e => onUpload(e)}/>
                    </div>
                </div>
                <h4>{t("CSV Field Details")}</h4>
                {loading ? <img src={CsvUploadLoaderBackground} alt="loading data"/> : (
                    templateInfo && (
                        <>
                            <div className="overflow-x-auto data-table small-data-table mb-4">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>{t("Field")}</th>
                                        <th>{t("Required")}</th>
                                        <th>{t("Requirements")}</th>
                                        <th>{t("Notes")}</th>
                                        <th>{t("Example")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {templateInfo.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.Field}</td>
                                            <td>{item.Required}</td>
                                            <td>{item.Requirements}</td>
                                            <td>{item.Notes}</td>
                                            <td>{item.Example}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default UploadCsv;
